module.exports = __webpack_public_path__ + "img/time-nutrition-2.4dc7067.svg";